import { Box, Text, HStack } from '@chakra-ui/react'
import { faCircleBolt } from '@fortawesome/pro-solid-svg-icons'
import _ from 'lodash'
import { ItList } from 'types/graphql'

import Icon from 'src/components/widgets/Icon'

const StatusLabel: React.FC<{
  locked: boolean
  itList: ItList
  isPreview: boolean
}> = ({ locked, itList, isPreview }) => {
  const isOwner = itList.relationship === 'owner'
  return (locked && !isOwner) || isPreview ? null : (
    <Box px={{ base: 4, lg: isPreview ? 4 : 24 }}>
      <HStack>
        <Icon icon={faCircleBolt} color="meadow.300" size="xs" />
        <Text
          color="meadow.300"
          className="body-extra-small-emphasis"
          ml={4}
          data-testid="itListDetails-unlockedLabel"
        >
          {isOwner ? 'LIVE' : 'UNLOCKED'}
        </Text>
      </HStack>
    </Box>
  )
}

export default StatusLabel
